import React, { Component } from 'react'
import { connect } from 'react-redux'
import SidebarItems from '../lists/SidebarItems'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import { itemIdsToItems } from '../item/itemsTransformers'
import { fetchPopular } from '../item/popularActions'
import { MIN_POPULAR_CLICKS } from './PopularNewsListBox'


@connect((state) => {
  const { popular } = state
  return {
    items: itemIdsToItems(state, popular.get('itemIds')),
    itemIds: popular.get('itemIds'),
    loading: popular.get('loading'),
    shouldUpdate: popular.get('shouldUpdate'),
    failedToLoad: popular.get('failedToLoad'),
  }
})


export default class SidebarPopular extends Component {
  static propTypes = exact({
    items: ImmutablePropTypes.orderedSet.isRequired,
    itemIds: ImmutablePropTypes.orderedSet.isRequired,
    loading: PropTypes.bool.isRequired,
    shouldUpdate: PropTypes.bool.isRequired,
    failedToLoad: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    category: ImmutablePropTypes.record,
    tag: ImmutablePropTypes.record,
  })

  shouldComponentUpdate(nextProps) {
    if (nextProps.shouldUpdate) { // trigger fetch after changes to black/whitelists
      this.dispatchRefresh(true)
    }
    return this.props.itemIds !== nextProps.itemIds ||
           this.props.loading !== nextProps.loading ||
           this.props.failedToLoad !== nextProps.failedToLoad ||
           this.props.category !== nextProps.category ||
           this.props.tag !== nextProps.tag
  }

  componentDidMount() {
    this.updateInterval = setInterval(this.dispatchRefresh, 5000)
  }

  componentWillUnmount() {
    clearInterval(this.updateInterval)
    this.updateInterval = null
  }

  dispatchRefresh = (force = false) => {
    if (window.document.hidden) return

    const { dispatch, category, tag } = this.props
    const cacheTTL = category || tag ? 900 : 300 // cat/tag popular changes slowly, so longer cache
    const categoryId = category?.id
    const tagId = tag?.id

    dispatch(fetchPopular(force ? 0 : cacheTTL, { categoryId, tagId }))
  }

  render () {
    const {
      dispatch,
      items,
      loading,
      failedToLoad,
      category,
      tag,
    } = this.props

    if (items.size < 5 || items.last().get('clicks', 0) < MIN_POPULAR_CLICKS) {
      return null
    }

    let title = 'Luetuimpia'
    if (category) {
      title = 'Luetuimpia: ' + category.get('name')
    }
    if (tag) {
      title = 'Luetuimpia: #' + tag.get('name')
    }

    return (
      <SidebarItems
        title={ title }
        linkTo='/luetuimmat'
        linkToTitle='Näytä luetuimmat uutiset'
        className='popular'
        trackingClass='suosittuja-sidebar'
        dispatch={ dispatch }
        loading={ loading }
        failedToLoad={ failedToLoad }
        items={ items }
        emptyText=''
      />
    )
  }

}
